import { Heading } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";

const BrandsView = () => {
  return (
    <>
      <Heading as={"h2"} p={3}>
        E-commerce - Brands
      </Heading>

      <Outlet />
    </>
  );
};

export default BrandsView;
